import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";

export const actionTypes = {
    ActionsLoading: '[Actions loading] Action'
};

const initialActionState = {
    actionsLoading: true
};

export const reducer = persistReducer(
    {storage, key: "trendyol-key", whitelist: ["actionsLoading"]},
    (state = initialActionState, action) => {
        switch (action.type) {
            case actionTypes.ActionsLoading: {
                return {...state, actionsLoading: action.payload}
            }

            default:
                return state;
        }
    }
);

export const actions = {
    actionsLoadingAction: data => ({type: actionTypes.ActionsLoading, payload: data})
};